import { render, staticRenderFns } from "./landing-voa.vue?vue&type=template&id=08ac81d8"
import script from "./landing-voa.vue?vue&type=script&lang=js"
export * from "./landing-voa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports